<template>
    <div>
        <div class="content-box first" v-loading="certificationLoading" element-loading-text="认证中...">
            <TitleTip>此处信息为认证信息，将会提供给第三方进行存证，用于签署合同、授权合约等</TitleTip>
            <RsStep class="full m-b-8" :active="0" :steps="['身份认证', '签署合同', '签署完成']"></RsStep>
            <el-form
                v-loading="pageLoading"
                :model="formData"
                :disabled="isDisabled"
                ref="formData"
                :rules="rules"
                label-width="160px"
                class="main-form label-left"
            >
                <el-form-item prop="personName" label="姓名">
                    <el-input
                        v-model="formData.personName"
                        placeholder="个人真实姓名，需要和证件上保持一致"
                        :disabled="!!formData.reVerifyType"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="认证手机号"
                    :rules="[
                        {required: true, message: '请输入认证手机号'},
                        {regexp: /^\d{11}$/, message: '请输入正确的手机号码'},
                    ]"
                >
                    <el-input
                        v-model="formData.telephone"
                        min="11"
                        max="11"
                        placeholder="请填写手机号"
                        :disabled="!!formData.reVerifyType"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="personIdCard" label="证件编号">
                    <el-input
                        v-model="formData.personIdCard"
                        :maxlength="18"
                        :minlength="18"
                        placeholder="和证件上保持一致"
                        :disabled="!!formData.reVerifyType"
                        @input="handleIdNumInput"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="idName" label="证件类型">
                    <el-select v-model="formData.idName">
                        <el-option :value="1" label="身份证"></el-option>
                        <!-- <el-option :value="2" label="护照"></el-option> -->
                    </el-select>
                </el-form-item>
                <el-form-item prop="idPhoto2" label="证件正反面">
                    <div class="flex" style="justify-content: space-between">
                        <ImageUpload
                            class="no-tips"
                            :size="10"
                            :url.sync="formData.idPhoto"
                            fixedNumber="4:3"
                            accept="image/png,image/jpeg"
                            @onSuccess="onImageUpload($event, 'idPhoto')"
                        >
                            <div slot="tips">&nbsp;</div>
                        </ImageUpload>
                        <ImageUpload
                            class="no-tips"
                            :size="10"
                            fixedNumber="4:3"
                            :url.sync="formData.idPhoto2"
                            accept="image/png,image/jpeg"
                            @onSuccess="onImageUpload($event, 'idPhoto2')"
                        >
                            <div slot="tips">&nbsp;</div>
                        </ImageUpload>
                    </div>
                </el-form-item>
                <el-form-item prop="protocol">
                    <el-checkbox v-model="formData.protocol" :true-label="1" :false-label="0">
                        我已阅读
                        <el-link class="link base" href="/help?key=privacyagreement" target="_blank">《实名认证隐私协议》</el-link>
                    </el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit()">进行认证</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import {MessageBox, Loading} from 'element-ui';
export default {
    components: {
        ImageUpload,
    },
    data() {
        return {
            certificationLoading: false,
            pageLoading: false,
            formData: {
                personName: '',
                personIdCard: '',
                idName: 1,
                telephone: '',
                idPhoto: '',
                idPhoto2: '',
                protocol: 0,
                reVerifyType: null,
            },
            rules: {
                personName: [{required: true, message: '请输入个人真实姓名'}],
                personIdCard: [
                    {
                        required: true,
                        message: '请填写证件编号',
                        validator: (rule, value, callback) => {
                            const trimmed = value ? value.trim() : '';
                            callback(trimmed ? undefined : new Error(rule.message));
                        },
                    },
                    //禁止纯空格内容
                    {
                        pattern: /[^\s]/,
                        message: '证件编号不能全为空格',
                    },
                ],
                idPhoto2: [{required: true, message: '请上传证件照片'}],
                protocol: [
                    {
                        required: true,
                        validator: (rule, value, callback) =>
                            value == 1 ? callback() : callback(new Error('请仔细阅读《实名认证隐私协议》后，进行勾选')),
                    },
                ],
            },
            status: 0, // 0 未认证 1 继续认证 2 认证完成 3 认证失败
            fddInfo: {},
            routerParams: {},
            originalFormData: null, //初始数据
        };
    },
    computed: {
        isDisabled() {
            const {status} = this;
            if (status !== 2) return false;
            return true;
        },
    },
    mounted() {
        if (sessionStorage['routerParams']) {
            this.routerParams = JSON.parse(sessionStorage['routerParams']) || {};
        }
        this.formData.reVerifyType = this.$route.query?.reVerifyType || this.routerParams.reVerifyType;
        this.certificationInfo();
    },
    methods: {
        /**
         * 等待确认
         * @param status 0: 未认证 1: 继续认证 2: 认证完成 3: 认证失败
         * @param url 跳转的路径
         * @param transactionNo 事务编号
         * 状态为1、2 都要调用verifyFinish 来判断是否真正的认证成功
         */
        async waitConfirm(status, url, transactionNo) {
            const flag = await this.$fadadaConfirm('实名认证', '请确认是否完成了实名认证', [1, 2].includes(status) ? 2 : status, url);
            //按钮：完成认证
            if (flag == 'success') {
                const params = this.formData.reVerifyType ? {transactionNo} : null;
                const respnonse = await this.$request({
                    url: '/fabigbig/verifyFinish',
                    params,
                    method: 'GET',
                });
                const {state, msg, result} = respnonse.data;
                if (!state) return this.$message.error(msg || '认证失败');
                //真正的认证成功
                if (result == false) {
                    MessageBox.confirm('认证信息更新可能会延迟1-2分钟，如果您确认认证成功，请您稍后刷新页面', '提示', {
                        confirmButtonText: '我知道啦',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(() => {})
                        .catch(() => {});
                } else {
                    this.$message.success('实名认证成功');
                    await this.$store.dispatch('getUserInfo');
                    sessionStorage.removeItem('routerParams');
                    //合同已签约:跳转到首页
                    if(this.$store.getters.userState > 2) {
                        return (window.location.href = '/manage/accountManage');
                    } else {//合同未签约:跳转到签署合同
                        if (this.formData.reVerifyType == 3) {
                            return (window.location.href = '/manage/contract/verify/fdd/step/2');
                        } else {
                            return (window.location.href = this.$contractRouter('/manage/contract/verify/fdd/step/2', 'url'));
                        }
                    }
                }
            }
            //按钮：继续认证
            if (flag == 'refresh') return this.certificationInfo();
        },
        // 识别用户身份信息
        async identifyUserInfo() {
            const {idPhoto, idPhoto2} = this.formData;
            const response = await this.$request.post('/letSign/idCardDiscern', {backImage: idPhoto2, frontImage: idPhoto}, {formData: false});
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '身份信息识别失败');
            const {personName, personIdCard, gender, identyCity, identyCityCode, identyDistrict, identyProvince, identyProvinceCode, personAddress} =
                result || {};
            this.formData = {
                ...this.formData,
                personName,
                personIdCard,
                gender,
                identyCity,
                identyCityCode,
                identyDistrict,
                identyProvince,
                identyProvinceCode,
                personAddress,
            };
        },
        onImageUpload() {
            const {idPhoto, idPhoto2} = this.formData;
            if (idPhoto && idPhoto2) {
                // this.identifyUserInfo();
                this.$refs['formData'].clearValidate(['idPhoto', 'idPhoto2']);
            }
        },
        // 获取认证信息
        async certificationInfo(url, transactionNo) {
            this.pageLoading = true;
            const response = await this.$request.post(
                '/fabigbig/getIdentificationInformation',
                {reVerifyType: this.formData.reVerifyType},
                {formData: false}
            );
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '获取用户信息失败');
            this.pageLoading = false;
            const {telephone, idNum, idPhoto, idPhoto2, verifyName, isVerify, verifyUrl} = result || {};
            this.formData = {...this.formData, telephone: telephone, personIdCard: idNum, idPhoto, idPhoto2, personName: verifyName};
            this.fddInfo = result;
            //存储副本信息
            this.originalFormData = {
                personName: this.formData.personName,
                telephone: this.formData.telephone,
                personIdCard: this.formData.personIdCard,
                idPhoto: this.formData.idPhoto,
                idPhoto2: this.formData.idPhoto2,
            };
            if (this.routerParams.telephone) {
                this.formData.telephone = this.routerParams.telephone;
            }
            if (this.$route.query?.telephone) {
                this.formData.telephone = atob(this.$route.query?.telephone);
            }
            if (this.$route.query?.name) {
                this.formData.personName = decodeURIComponent(this.$route.query?.name);
            }
            if (this.routerParams.personName) {
                this.formData.personName = this.routerParams.personName;
            }
            if (this.fddInfo.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            //有事务编号且认证状态为1 就弹框：实名认证
            if (result.transactionNo && isVerify == 1) {
                this.waitConfirm(isVerify, url || verifyUrl, transactionNo || result.transactionNo);
            }
            //有事务编号且认证状态为2 就跳转到实名认证中
            if (result.transactionNo && isVerify == 2) {
                //合同已签约:调用重新认证接口
                if(this.$store.getters.userState > 2) {
                    let loadingInstance = Loading.service({fullscreen: true, text: '正在请求中，请稍后...'});
                    this.formData.reVerifyType = this.routerParams.reVerifyType || this.$route.query?.reVerifyType;
                    const response = await this.$request.post('/fabigbig/personCert', this.formData, {formData: false});
                    const {msg, state} = response.data;
                    loadingInstance.close();
                    if (!state) return this.$message.error(msg || '认证失败');
                    this.$message.success('实名认证成功');
                    await this.$store.dispatch('getUserInfo');
                    sessionStorage.removeItem('routerParams');
                    return (window.location.href = '/manage/accountManage');
                } else {
                    //未签约：跳转到签合同
                    if (this.formData.reVerifyType == 3 || this.$route?.query?.type == 'dzq') {
                        return (window.location.href = '/manage/contract/verify/fdd/step/2');
                    } else {
                        return (window.location.href = this.$contractRouter('/manage/contract/verify/fdd/step/2', 'url'));
                    }
                }
            }
        },
        // 判断监控的字段是否发生变化
        hasFormDataChanged() {
            if (!this.originalFormData) {
                return false;
            }
            // 定义需要比较的字段列表
            const columnsCheck = ['personName', 'telephone', 'personIdCard', 'idPhoto', 'idPhoto2'];
            // 已修改
            return columnsCheck.some((field) => this.formData[field] !== this.originalFormData[field]);
        },
        // 提交认证信息
        async submitCertification() {
            if (this.fddInfo.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            let url = '';
            let transactionNo = '';
            //重新发起认证 类型 默认 null,1 电话号码 2 姓名
            if (this.routerParams.reVerifyType || this.$route.query?.reVerifyType) {
                this.pageLoading = true;
                this.formData.reVerifyType = this.routerParams.reVerifyType || this.$route.query?.reVerifyType;
                const response = await this.$request.post('/fabigbig/personCert', this.formData, {formData: false});
                const {msg, state, result} = response.data;
                this.pageLoading = false;
                if (!state) return this.$message.error(msg || '认证失败');
                url = result?.verifyUrl;
                transactionNo = result?.transactionNo;
            }
            //非重新认证
            else {
                if (this.fddInfo.verifyUrl && !this.hasFormDataChanged()) {
                    url = this.fddInfo.verifyUrl;
                    transactionNo = this.fddInfo.transactionNo;
                } else {
                    this.pageLoading = true;
                    const response = await this.$request.post('/fabigbig/personCert', this.formData, {formData: false});
                    const {msg, state, result} = response.data;
                    this.pageLoading = false;
                    if (!state) return this.$message.error(msg || '认证失败');
                    url = result?.verifyUrl;
                    transactionNo = result?.transactionNo;
                    if (result) {
                        this.originalFormData = {
                            personName: this.formData.personName,
                            telephone: this.formData.telephone,
                            personIdCard: this.formData.personIdCard,
                            idPhoto: this.formData.idPhoto,
                            idPhoto2: this.formData.idPhoto2,
                        };
                    }
                }
            }
            const h = this.$createElement;
            // 确认认证
            const flag = await this.$msgbox({
                title: '前往电子合同平台“法大大”',
                message: h('div', null, [
                    h('p', null, '即将前往电子合同平台“法大大”，在该平台，你将，'),
                    h('p', null, '1. 完成电子实名认证'),
                    h('p', null, '2. 授权“秀动发行”获取您的实名认证信息'),
                    h('p', null, '请放心使用'),
                ]),
                confirmButtonText: '确认前往',
            });
            if (flag === 'cancel') return;
            window.open(url);
            this.certificationInfo(url, transactionNo);
        },
        async onSubmit() {
            this.$refs['formData'].validate(async (valid) => {
                if (!valid) return;
                this.submitCertification();
            });
        },
        handleIdNumInput(value) {
            // 移除所有空格（包括中间空格）
            const cleanedValue = value.replace(/\s+/g, '');
            this.formData.personIdCard = cleanedValue;
            this.$nextTick(() => {
                this.$refs.formData.validateField('personIdCard');
            });
        },
    },
};
</script>
<style lang="scss"></style>
